<template>
  <nav class="footer-menu" v-if="!!footerMenu">
    <ul v-for="(columnMenu, columnIx) in footerMenu.items" :key="columnIx" class="footer-menu__column">
      <li v-for="(menuItem, ix) in columnMenu.items" :key="ix" class="footer-menu__item"
          :class="{'footer-menu__item_feedback': menuItem.code === 'FEEDBACK'}">
        <a :class="{'feedback': menuItem.code === 'FEEDBACK'}" :href="menuItem.targetUrl"
           :target="menuItem.isLocalUrl ? '_self' : '_blank'">{{ menuItem.title }}</a>
      </li>
    </ul>
  </nav>
  <nav v-else class="footer-menu">
    <ul class="footer-menu__column">
      <li v-for="ix in 5" :key="ix" class="footer-menu__item data-waiting-animation" style="width: 150px">&nbsp;</li>
    </ul>
    <ul class="footer-menu__column">
      <li v-for="ix in 4" :key="ix" class="footer-menu__item data-waiting-animation" style="width: 150px">&nbsp;</li>
    </ul>
    <ul class="footer-menu__column">
      <li v-for="ix in 5" :key="ix" class="footer-menu__item data-waiting-animation" style="width: 150px">&nbsp;</li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    footerMenu: Object,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
*,
*:link,
*:visited,
*:hover,
*:active {
  color: inherit;
}

.footer-menu__column {
  flex: 1 1 0;
  list-style-type: none;
  margin-bottom: 0;
}

.footer-menu__item {
  + .footer-menu__item {
    margin-top: 15px;
  }

  &.footer-menu__item_feedback {
    margin-top: 35px;
    
    body[theme="longitours"] & {
      display: none;
    }
  }
}

.feedback {
  display: inline-block;
  background-color: var(--btn-primary);
  color: var(--btn-primary-text);
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  border-radius: var(--border-radius-md);
  outline: none;
  min-width: 264px;
  text-align: center;
  
  &:hover {
    box-shadow: var(--shadow-hover);
  }
  
  &:active {
    background-color: var(--btn-primary-active);
  }
}
</style>


